<div class="check-circle">
  <mat-icon>check</mat-icon>
</div>

<h2>All set! You can safely close this tab</h2>
<p>Your response has been submitted successfully</p>

<div class="actions">
  <button mat-stroked-button *showIfPermitted="permission.ORDER_LIST" (click)="router.navigate(['/orders'])">
    <mat-icon>arrow_back</mat-icon>
    Go to Orders
  </button>
  <button mat-flat-button (click)="navigateToPreview()">
    <mat-icon>visibility</mat-icon>
    Preview Order
  </button>
</div>
